//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "deviceInfo",

  data(){
    return {
      deviceIdData: {},
      deviceInfo: {}
    }
  },
  mounted() {
    this.$http.get("../static/api/api.json").then(response => {
      this.apiurl = response.api;
      this.deviceIdData = JSON.parse(this.$route.params.data);
      this.getDeviceInfo(this.deviceIdData.deviceId)
    });
  },
  methods: {
    getDeviceInfo(id){
      this.$http
        .get(this.apiurl + "/web/device/detail/" + id)
        .then(res => {
          if (res.code === 0) {
            this.deviceInfo = res.data
          }
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/deviceInfo.vue